import React from "react";
import { type IIconInterface } from "../icon.interface";
import { SvgIcon } from "../SvgIcon";

export const HouseIcon: React.FC<IIconInterface> = (props): JSX.Element => {
  return (
    <SvgIcon title="House" viewBox="0 0 24 24" {...props}>
      <path
        d="M20.249 20.2498V10.8316C20.249 10.7271 20.2272 10.6238 20.1849 10.5282C20.1426 10.4326 20.0809 10.347 20.0035 10.2767L12.503 3.45775C12.365 3.33223 12.1851 3.26269 11.9985 3.2627C11.8119 3.2627 11.632 3.33226 11.494 3.45778L3.99447 10.2767C3.91716 10.347 3.85539 10.4326 3.81312 10.5282C3.77086 10.6238 3.74902 10.7271 3.74902 10.8316V20.2498"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.49902 20.25H22.499"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.249 20.249V14.999C14.249 14.8001 14.17 14.6093 14.0294 14.4687C13.8887 14.328 13.6979 14.249 13.499 14.249H10.499C10.3001 14.249 10.1093 14.328 9.96869 14.4687C9.82804 14.6093 9.74902 14.8001 9.74902 14.999V20.249"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
